import { IconButton, InputGroup, InputProps, InputRightElement } from '@chakra-ui/react'
import { useState } from 'react'
import { EyeIcon } from '../icons'
import Input from "../input"


function InputPassword(props: InputProps) {

  const [show, setShow] = useState(false)
  const handleClick = () => setShow(!show)

  return (
    <InputGroup>
      <Input {...props} type={show ? 'text' : 'password'}/>
      <InputRightElement>
        <IconButton aria-label="Show" icon={<EyeIcon />} variant="icon" onClick={handleClick} />
      </InputRightElement>
    </InputGroup>
  )
}

export default InputPassword